
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Clear`,
'deleteKey': `⌦ Διαγραφή`,
'downKey': `↓ Κάτω`,
'endKey': `⤓ Τέλος`,
'enterKey': `Εισάγετε το`,
'escapeKey': `⎋ Απόδραση`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Δημιουργήστε ένα 
          <code>LICENSE 
          </code> αρχείο 
        `,
'homeKey': `⤒ Αρχική σελίδα`,
'keyCommand': `⌘ Εντολή/Win`,
'keyControl': `^ Έλεγχος`,
'keyOption': `⌥ Επιλογή/Alt`,
'keyShift': `⇧ Μετατόπιση`,
'leftKey': `← Αριστερά`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Δεξιά`,
's00065e45db8c0441': `Ανατρέξτε στην ενότητα Εργαλεία προγραμματιστών για περισσότερες λεπτομέρειες`,
's001dd78415a91fa0': `Κοπή γραμμής κύλισης`,
's002fa7d1054ed082': `Πλαίσιο πλαισίου`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Καζακστάν`,
's01b56d233c6c5cac': `Διαχωρισμός`,
's01d32b35baa3b676': `Συγγραφέας`,
's02106cc2ef0e7578': `Νέα καρφίτσα...`,
's02ab1ea8e5100fc1': `Χαρακτηρίστε την επιλογή ως "αμφίδρομη παράκαμψη".`,
's0312976fe9da5951': `Κουμπί`,
's03608a32f05eded2': `Ζουμ με τσίμπημα`,
's036d35e03be98d22': `Μαθηματικό βάθος`,
's037b1dc850a89273': `Εναλλακτική λύση στο πλαίσιο`,
's0396202b716732ec': `Σημειώστε την επιλογή ως διαγραμμένη`,
's03f49e598ffb11cc': `Πολωνικά`,
's0448f1059fa01720': `Αποθηκεύστε, μοιραστείτε ή εκτυπώστε την εξερεύνησή σας. Επεξεργαστείτε πληροφορίες όπως ο τίτλος, η γλώσσα ή η άδεια χρήσης.`,
's0458872c43beadef': `Εισαγωγή γραμμής πριν`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Απόσταση λέξεων`,
's05e9759cfd99c48f': `Δικαιολογήστε το`,
's063fa5a0a4903bf4': `Πλάγια, από αριστερά προς τα δεξιά`,
's064339c229374050': `Κωδικοποίηση`,
's06634274f19b0572': `Επιλογή ακροδεκτών`,
's06743b24499f0035': `Κέντρο άγκυρας`,
's07808b0ca6da8fef': `Περιφραγμένη ιστοσελίδα`,
's07970793b21351fd': `Δοχείο βάσης Ruby`,
's079cf7850d9327f0': `Γραμματοσειρά`,
's07aa10850d9ddcc7': `Έντυπο`,
's07e6118e838b2e23': `Πλοήγηση`,
's0816468df86e4036': `Ανοίγει τις ρυθμίσεις`,
's082869038c117fe5': `Πορτογαλικά (Βραζιλία)`,
's086e6c267ade2609': `Κορεσμός`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Ήχος`,
's0978fb5ba3145996': `Εισαγωγή μιας λίστας (μη ταξινομημένης)`,
's09c3f1d21de14ae1': `Σημειώστε την επιλογή ως υπογραμμισμένη`,
's0a2d91c6720033e9': `Περικοπή διαστήματος κειμένου`,
's0a3ddcba94027d95': `Εφαρμογή αντικειμένου`,
's0a6cb8d42cdb0c4a': `Εσπεράντο`,
's0a799f583098cadf': `Εισαγωγή πλοήγησης`,
's0a7db790db1fc45c': `Χαρακτηρίστε την επιλογή ως έκταση`,
's0b1271f50a77dc73': `Κουτί περιεχομένου`,
's0b24d08ea349b455': `Όλα όσα μπορείτε να εισάγετε. Στην αρχή είναι τα μη διαδραστικά στοιχεία, όπως λίστες ή εικόνες, και στη συνέχεια τα διαδραστικά στοιχεία που ονομάζονται widgets. Μπορείτε να βρείτε νέα κάνοντας κλικ στη γραμμή αναζήτησης.`,
's0bdca49248ba4820': `Συντομεύσεις`,
's0befccf152b6c0a9': `Προσανατολισμός από μεταδεδομένα`,
's0c11e479416c8421': `Εισαγωγή λεζάντας πίνακα`,
's0c27336067c59611': `Μαξιλάρι κύλισης`,
's0c4593d81f147042': `Βασική γραμμή`,
's0c4b2e98d4ab7f5a': `Εντολές εφαρμογής`,
's0c883713b83616a8': `Αποθήκευση του ενεργού εγγράφου`,
's0ca5c0460199cba1': `Συντομογραφία`,
's0cf10c4f40588f8d': `Λεζάντα πίνακα`,
's0d86afa3c6a1e28b': `Κατεύθυνση Flex`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Το εξερεύνητο έγγραφό σας. Μπορείτε να γράψετε κείμενο και να κάνετε αντιγραφή/επικόλληση, επεξεργασία κ.λπ. εδώ.`,
's0dc452999c129e15': `Ενεργοποίηση ζωντανής επαναφόρτωσης`,
's0de0febab8a4beaf': `Σφάλμα ανάγνωσης αυτού του πακέτου`,
's0e44968489e076a8': `Κινέζικα`,
's0e4862e87c7d53ce': `Σημειώστε την επιλογή ως παράθεση`,
's0e6ea8870dbddab2': `Εντολές εγγράφων`,
's0ee28503778e4c0c': `Τελευταία γραμμή βάσης`,
's0ef01c03299bbb83': `Διακόσμηση`,
's0f17f32919661cff': `Μογγολικά`,
's0f350bc4e538e3ea': `Λέξεις`,
's105a06836c40fcb4': `Ορισμός φίλτρων, χρώματος και ανάμειξης επιλεγμένων στοιχείων`,
's106b274b5af798e5': `Προτάσεις`,
's1082e1649793dca9': `Σημειώστε την επιλογή ως ορισμένο όρο`,
's10f3845975a0351e': `Επεξεργασία μεταδεδομένων`,
's1125d159f7e64df5': `Εμφάνιση`,
's11326fd2590f4e5e': `Προεπιλογή`,
's1155ec07a221e739': `Γραμμή κύλισης`,
's1173bf7a3e0b74c9': `Ελάχιστο (y)`,
's1177237a3e0e548c': `Ελάχιστο (x)`,
's1219d97b49650c05': `Ορατότητα`,
's123bea44f38abccf': `Εισαγωγή αντικειμένου`,
's1245e2cb9f20197e': `Ευθυγράμμιση`,
's12946ec1b850962c': `Εισαγωγή στήλης μετά`,
's1351209ef74ee729': `Εκτείνετε όλες τις στήλες`,
's13c60cb409e8cb6f': `Ευθυγράμμιση στο κέντρο`,
's13ebd619c8a06a6d': `Αυτόματες γραμμές πλέγματος`,
's13ef8ca26ca8861b': `Στοιχείο κοπής`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Κεφαλή τραπεζιού`,
's156647179b21d351': `Εισαγωγή σώματος πίνακα`,
's158b6ec6b1fffcb2': `Διάλειμμα μετά`,
's15d0c0657c1ee08c': `Κλειδί API`,
's1626a7e10a9f9dcc': `Ορίζει την οικογένεια γραμματοσειράς της επιλογής`,
's1637c7d1a30629e2': `Πλαίσιο πλαισίου`,
's1641ab440bf4daa4': `Ενημερώστε αυτό το πακέτο widget`,
's166bd56d19670a72': `Ζουμ`,
's1696c76a23c0834e': `Προχωρημένο: Εμφάνιση πακέτων με εκδόσεις όπως 0.x.x στο διαχειριστή πακέτων`,
's16b9446e3a70e1f4': `Χαρακτηριστικά`,
's16f205466761e583': `Δεν υπάρχει οπτικό μέγεθος γραμματοσειράς`,
's16f2f1c2c516d307': `Ανοίξτε ένα έγγραφο`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Άδεια`,
's17bfaaa4e7528bc7': `Μπασκίρ`,
's17fb3f4805f4f4b9': `Αφαίρεση πεδίου`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Δημιουργία πακέτου`,
's18d5c44aae3dc82a': `Σε απευθείας σύνδεση κατά την επεξεργασία`,
's1988d71ef8060edf': `Εισαγωγή γραμμής πίνακα`,
's19abee1277c9bca2': `Σαμόα`,
's19daf2f26c19543d': `Περίγραμμα`,
's1a1acc902e6668e0': `Εμφάνιση προηγμένης μορφοποίησης κειμένου`,
's1a5230a71d9285c1': `Σύλληψη`,
's1aa1cb63ad44bc6f': `Διάκενο στήλης`,
's1af8b67d1c85c811': `Διάστημα μεταξύ`,
's1b4a36fce2456660': `Οικογένεια γραμματοσειράς`,
's1c246045629b0016': `Σημειώστε την επιλογή ως διαγραφή`,
's1c3fc313a9184670': `Δημόσιος σύνδεσμος`,
's1c65f5004a07dcfa': `Σκωτσέζικα γαελικά`,
's1c690963f1e2df00': `Ειδική εμφάνιση πλατφόρμας`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Θέλετε μια σύντομη ξενάγηση;`,
's1d19244f549ec535': `Εκπαίδευση`,
's1d5c7b28e8b50d6d': `Associate deg.`,
's1db591f5a54dbfd3': `Πλαίσιο περιεχομένου`,
's1dbb9f50e16c92a3': `Ακτίνα συνόρων`,
's1dfb744260fb3a01': `Αμφίδρομη απομόνωση`,
's1e9c2c654732cc5f': `Λευκορωσία`,
's1eaccbf2d6af8ab5': `Πληροφορίες`,
's1efbfc3937d565bd': `Ιστορικό`,
's1f2b49c1bca2035d': `Καταλανικά`,
's1f74bdf32b51a5fc': `Εικόνα φόντου`,
's1f7698c061c208c9': `Ανοίξτε το`,
's1f8e59d0624842ff': `Κανάντα`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Κορσική`,
's21d61916eb8d137d': `Πίνακας Σώμα`,
's21d723a1dbcd89c8': `Τζαβανέζικα`,
's21f8a2eaf5a70749': `Εισαγωγή ετικέτας`,
's2206c42e5b835e6e': `Σημειώστε την επιλογή ως συντομογραφία`,
's22a2348c46a912a0': `Εισαγωγή τμήματος`,
's233ae776268cd44b': `Επιχείρηση`,
's236ed7ba747099b0': `Βάρος γραμματοσειράς`,
's2474e7fb1aec9f05': `Δοκιμή`,
's2492f5fb1b05b45e': `Κείμενο`,
's24949d7adbb5a098': `Εργαλειοθήκη`,
's252a52330d32b900': `Μεταδεδομένα`,
's2540844a4bc4d9ba': `Απαιτείται απόδοση;`,
's255857544a9d5ec0': `Επαναφορά`,
's255c77900f2b5e0f': `Χρωματικός συνδυασμός`,
's256ab831a48c941c': `Αφαιρεί όλη τη μορφοποίηση κειμένου από την επιλογή`,
's2591806d7b222591': `Επαναφορά αλλαγών`,
's25e1a07e454c2c11': `Πλέγμα`,
's262abbaf1d05f009': `Απαλό φως`,
's266935f2447fcd98': `Πάνω από αριστερά`,
's268ecd1cef45a9a8': `Είσαι σίγουρος;`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Φωτίστε το`,
's27076e66c5d483ba': `Κάθετη ευθυγράμμιση`,
's2712dc5641a33226': `Οι λογαριασμοί μητρώου πακέτων προορίζονται για προγραμματιστές και σας επιτρέπουν
          να διαμορφώσετε ένα ή περισσότερα μητρώα`,
's27cc88818cc46ff6': `Σταθερό`,
's281d957112b10f12': `Επεξεργαστείτε απευθείας την HTML του εγγράφου`,
's28b6246ce616a548': `Εισαγωγή ομάδας στηλών πίνακα`,
's29a1c26521879b9f': `Κλιμάκωση προς τα κάτω`,
's29acfd2778e8c377': `Απόκρυψη προηγμένης μορφοποίησης κειμένου`,
's29b24c06315e9343': `Εισαγωγή εισόδου`,
's29eb103449472e3b': `Εισαγωγή επικεφαλίδας (επίπεδο 3)`,
's29ee7434494a0dfe': `Εισαγωγή επικεφαλίδας (επίπεδο 2)`,
's29f21c34494d614d': `Εισαγωγή επικεφαλίδας (επίπεδο 1)`,
's29fbfc3449557f72': `Εισαγωγή επικεφαλίδας (επίπεδο 6)`,
's29ff743449588131': `Εισαγωγή επικεφαλίδας (επίπεδο 5)`,
's2a031834495bcdb4': `Εισαγωγή επικεφαλίδας (επίπεδο 4)`,
's2a75c946ef4dcab7': `Διάφορα`,
's2b2ae20d26f78ac2': `Μπλοκ`,
's2b8f50c64be440f7': str`Επιλέξτε 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Παραγγελία`,
's2bad2d24def4aa0b': `Διακοπή γραμμής (γλώσσα CJK)`,
's2ceb11be2290bb1b': `Ακύρωση`,
's2ced8e8fafb499f6': `Διαγραφή στοιχείου`,
's2d986d31f8d67357': `Εισαγωγή ενός συνόλου πεδίων`,
's2d995a37cf5e4995': `Εισαγωγή ενός NoScript`,
's2de969afacdaa7a6': `Σχήμα`,
's2df075aface0dab8': `Μοιραστείτε το`,
's2e192b19ed15fcf6': `Σελίδα`,
's2e39b99cf23606fa': `Ορισμός της διάταξης των επιλεγμένων στοιχείων`,
's2e4818861000b13f': `Διάταξη`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Μαράθι`,
's2eda5288a65bca1d': `Υπερχείλιση (y)`,
's2edd6688a65e21f0': `Υπερχείλιση (x)`,
's2f0bcdffc92a786b': `Πλεύση δεξιά`,
's2f2044f2431a32d5': `Κεφαλή`,
's2f4d4bfbc466d91f': `Αλβανικά`,
's2f8da2cb5f236588': `Το όνομα του πακέτου σας. Πρέπει να έχει εμβέλεια, π.χ. \`@org/pkg\`. `,
's30cce87854901922': `Προσχολική ηλικία`,
's3124653c272f054c': `Χρώμα κανόνα στήλης`,
's314a4f7685c8e824': `Πάντα`,
's31c06e226322f065': `Αποφύγετε τα ορφανά`,
's323dcde72b850272': `Πρόσβαση του κοινού`,
's32911e52ee8ac745': `Τοποθετήστε μια υποδοχή`,
's337a1e9022a8d19f': `Πίνακας`,
's33c1450d2822bb0f': `Εισαγωγή λεζάντας σχήματος`,
's33c18d5a4cbffa2a': `Ιρλανδική`,
's33f85f24c0f5f008': `Αποθήκευση`,
's342b0cabfa672822': `Βοηθήστε τον χρήστη να βρει το widget σας`,
's3437e0d9899e7ae1': `Αποστολή δεδομένων τηλεμετρίας σχετικά με τη χρήση του WebWriter.`,
's344ea8f4939cdc98': `Χρώμα`,
's34dcda3b0f9d5a98': `Εναλλαγή url`,
's34f724979a124c50': `Ορίζει το χρώμα φόντου του επιλεγμένου κειμένου`,
's355b21b89ce5d9c5': `Λεπτομέρειες`,
's35ae5f4e0fa2777b': `Προσαρμοσμένη ευθυγράμμιση`,
's35aeaff1425bca9e': `Το WebWriter δεν υποστηρίζει μέσα τύπου `,
's35c3125c7750681e': `Blockquote`,
's3643189d1abbb7f4': `Κωδικός`,
's3649bacefe731bf6': `Εναλλαγή εργαλειοθήκης`,
's365280e16a8ea32d': `Αντιγραφή της επιλογής`,
's366991b9c9287765': `Δεξιά`,
's36a194e38d653a26': `Σχολιασμός δεδομένων`,
's36b3cefdcb897f15': `Προοπτική`,
's372fae706048ce41': `Even-odd`,
's377e24af9628c37e': `Λίστα με σειρά`,
's37a8c35f6581da5f': `Χωρίς άγκυρα`,
's37fa3b9cd51c2dfd': `Ορίζει το μέγεθος γραμματοσειράς της επιλογής`,
's380d17664bb69531': `Εισαγωγή στήλης πριν`,
's3815184eb09f0dcf': `Δρομέας`,
's382a2aa3984474dd': `Δημιουργία`,
's38980f98cb07ceb8': `Αποθηκεύστε το ενεργό έγγραφο ως αντίγραφο`,
's3914cb410fca44d4': `Εισαγωγή`,
's3a179f6db2972384': `Θέση Ruby`,
's3a5ca02f282d247e': `Μοιραστείτε...`,
's3ae67088bbefba98': `Πακέτα`,
's3b0ab4b52326316f': `Φως`,
's3bdad99768e11911': `Εξερεύνηση`,
's3cb47df8290fa94c': `Εισαγωγή μιας επιλογής`,
's3cf89cb47fdde7e9': `Σύνδεσμος`,
's3d09398e555ee5f9': `Προηγμένες επιλογές`,
's3d249bb480032121': `Λίστα`,
's3d3efd1e19bdcfb4': `Σχόλιο ημερομηνίας/ώρας`,
's3d6a732c792ccb9e': `Σχόλιο Ruby`,
's3d93f9ea0c5a13fa': `Εικόνα`,
's3d9548e211b958ce': `Παράλειψη επικαλύψεων`,
's3e092e9d1ee2c5bb': `Κλιπ`,
's3e78ddc9a48a608d': `Αρκετά`,
's3eb6d1e6e79ed7c4': `Δεν βρέθηκαν έγγραφα`,
's3eca5a034978754b': `Διαγραφή της επιλογής`,
's3f06e9abb6ebcb79': `Χαρακτήρες`,
's3f1e7a3f2b283d3b': `Περιθώριο`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Γκουτζαράτι`,
's3f7e097a9b2e6181': `Εισαγωγή ενός άρθρου`,
's3fd83566dd643d10': `Εισαγωγή λεζάντας`,
's3fe72792941c18f9': `Κείμενο κάτω`,
's3ffcdc5db5e7d0c5': `Αντίστροφη`,
's40e3826b7f74a3b5': `Pan (δεξιά)`,
's40f07d7859284a44': `Κυρίαρχη βασική γραμμή`,
's4101ada154a1b958': `Μέση`,
's410c465a5993f82d': `Ευκαιρία για διάλειμμα γραμμής`,
's41322d19c928c603': `ΤΠΕ`,
's417b90913e05bc17': `Προεπισκόπηση`,
's418f2020fe996832': `Επιβεβαίωση αλλαγών`,
's41c724f0698148e9': `Σημειώστε την επιλογή ως συντόμευση πληκτρολογίου`,
's41f65a763f8e44ab': `Ομάδα επικεφαλίδων πίνακα`,
's42721130228841b0': `Κουτί εγκεφαλικού επεισοδίου`,
's429bd646f1cf8bc6': `Οι λογαριασμοί Grammar LLM σας επιτρέπουν να χρησιμοποιείτε το API Grammar LLM για να διορθώνετε τη γραμματική στο κείμενο.`,
's429dd933ba95549b': `Εισαγωγή διεύθυνσης`,
's42e470ef1d707a28': `Αυτόματο παιχνίδι`,
's42ffdab1291fb3de': `Εισαγωγή γραμμής μετά`,
's430831017f3f0499': `Κλίση (y)`,
's430bd5017f42511c': `Κλίση (x)`,
's433ba70286202ceb': `Σπάστε όλα`,
's441b20a8a50e36b4': `Μακεδονικό`,
's445b8acb9206db6e': `Απορρίψτε και ακυρώστε`,
's446a924922651ea0': `Υπογράμμιση κειμένου`,
's44cdba92713de38e': `Περιοχή πλέγματος`,
's45518abd911471d0': `Κροατικά`,
's456a8d744313852a': `Χώρος γύρω από`,
's4634541f5056a546': `Αμπχαζία`,
's46d4abe6255cb9e1': `Επαναπροσδιορισμός συντόμευσης`,
's4730c232e7209c40': `Κόψτε και τα δύο`,
's474f0eec369d02a4': `Δείγμα εξόδου`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Σημειώστε την επιλογή ως σημείωση ημερομηνίας/ώρας`,
's47ebf3a8fb3b10c1': `Προσανατολισμός`,
's4802bb8eb52fbdeb': `Πύλη`,
's4802e47fe2e95134': `Επιλογή`,
's491d2919cd6ec3d9': `Απόχρωση`,
's497838412cb455f2': `Σκιά κειμένου`,
's4993444bfd3f3e5e': `Κατάρρευση`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Μάσκα`,
's49dd67aed00029ef': `Μαθηματικά`,
's49e763aed00877a8': `Κύρια`,
's4a894f57eba1cf1e': `Συντόμευση πληκτρολογίου`,
's4ac1ad6ecd6bd810': `Διάφορες εκδόσεις.`,
's4ad6e9d3c2365c98': `Σκληρό φως`,
's4b2c143acf931122': `Ύψος γραμμής`,
's4b58c01e2578f5e4': `Υπόμνημα`,
's4bbff4e008690da1': `Αποφύγετε τη σελίδα`,
's4c402ff5355fd310': `Αμφίδρομη παράκαμψη`,
's4caed5b7a7e5d89b': `Αγγλικά`,
's4cb38675a21b2c98': `Μη υποστηριζόμενος τύπος ιδιότητας '\${desc.type}' (επεξεργασία ως JSON)`,
's4cc8391f172c0cdf': `Διαγραφή ξενάγησης`,
's4d528b416ac8dee2': `Εισαγωγή ομάδας επικεφαλίδων`,
's4d546f6c87128d5b': `Πρώτα το διάστημα`,
's4dcb9315f6527f9c': `Εκτέλεση κατά την επαναφόρτωση`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Σφάλμα σύνδεσης`,
's4e361bf8eef3759a': `Σπάσιμο λέξης`,
's4ea0f21fc2a338a1': `Ανεβείτε`,
's4eace13b3ed74187': `Σχόλιο πλευράς`,
's4efee5b48a4593cb': `Βρόχος`,
's4f26e7cb7c0a8318': `Διανυσματικό σχέδιο`,
's4fd2e638aabb0bb3': `Το WebWriter υποστηρίζει την ενσωμάτωση πολλών διαφορετικών πηγών. Απλά επικολλήστε
          έναν σύνδεσμο προς το περιεχόμενο από:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Ταϊλάνδης`,
's5015a8fb33b98872': `Λεπτό`,
's50489ffb1bde152e': `Εισαγωγή`,
's5068560b8d39663d': `Χάρτης με δυνατότητα κλικ`,
's517acbf1f96324f9': `Βάρος`,
's523eb9043213ff0d': `Πλάγια`,
's52777d434baeed9b': `Εισαγωγή δείκτη προόδου`,
's52af5d7ac34c2163': `Σειρά πίνακα`,
's52e0bdc3ee304436': `Τοποθετήστε έναν μετρητή`,
's531056f039febd39': `Εισάγετε μια επιλογή`,
's536695196d0b6dc3': `Φερόες`,
's542fcefa0bbaed86': `Ανοίξτε ή κλείστε την εργαλειοθήκη (μόνο σε στενές οθόνες, διαφορετικά, η εργαλειοθήκη είναι πάντα ορατή στο πλάι).`,
's5432ad3c84273229': `Εικόνα`,
's543906d1db8b2283': `Επεξεργασία `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Καμπότζη`,
's54897f2764b0e4d0': `Εγκαταστήστε αυτό το πακέτο widget`,
's54cbfaf2a8da7818': `Παστού`,
's550839f3e4e205bb': `Σημειώστε την επιλογή ως πολύ σημαντική`,
's55905c735052d295': `Θεματικό διάλειμμα`,
's5590dbf7e425789d': `Ετικέτα`,
's5623aa2f83b05c76': `Θιβέτ`,
's564d1648b1ceee9f': `Μέχρι σήμερα`,
's565cd5ffb0158c46': `Αποφύγετε την περιοχή`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Πηγαίνετε πίσω`,
's5787c6d5b3b5541a': `Διαδρομή κλιπ`,
's579c69f419b6caef': `Ομαλή`,
's587ac858dd80f6fa': `Υποδείκτης`,
's58bec0ecd4f3ccd4': `Αυστηρό`,
's59404f5593c32fdc': `Κέρνινγκ γραμματοσειράς`,
's5941292bb77281ab': `Νορβηγικό Bokmål`,
's599dcd2472c75c19': `Παράγραφος`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Σημειώστε την επιλογή με ένα σχόλιο δεδομένων`,
's5a356677b61a6b7e': `Μολδαβική`,
's5b474b5c0ac0c7c4': `Ομάδα στηλών πίνακα`,
's5b517ac216f9ee62': `Πλευρικά`,
's5b8cc9bb61ddce15': `Εισάγετε μια παράγραφο`,
's5bba2ac2e53bd1fd': `Kirghiz`,
's5be80ad6b8301710': `Ενδογραμμική εκκίνηση`,
's5c1ecf88259b79f9': `Παρουσίαση`,
's5c2a1a52c0389c30': `Μηχανική`,
's5c63af7695445fcf': `Στυλ κειμένου`,
's5d18ca4c3111be6f': `Εισαγωγή κεφαλίδας πίνακα`,
's5d87c1e588f48d90': `Πρακτική`,
's5d929ff1619ac0c9': `Αναζήτηση`,
's5da52af9b083c29a': `Μοντέλο`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Συνδεθείτε`,
's5e2cba97c0d971bd': `Επαναφόρτωση πακέτων`,
's5e53415a6d5719ad': `Κοινωνικές επιστήμες`,
's5e6a7a0c30d2a270': `Παράλειψη επικαλύψεων (auto)`,
's5e9e8e4d21bafedc': `Παραγωγή τροφίμων`,
's5ed03bb1f3a15949': `Εικόνα`,
's5f43af3669b1e098': `Πηγή`,
's5feaf7fd7ee567c8': `Λέξη σπασίματος`,
's600fd23c9ce971e8': `Εκτύπωση του ενεργού εγγράφου`,
's602bbd28dae2c60f': `Αυτοεκκίνηση`,
's60ff598dfcf2c773': `Κάτω από το δικαίωμα`,
's61053f0e3ebbd272': `κανονικό`,
's613c6ff83883c04f': `Στήλη πίνακα`,
's6196153c4b0c1ea0': `Εγκαταστήστε το`,
's61c017f6d5c303af': `Frisian`,
's61ded17ca3f48c82': `Μετατόπιση υπογράμμισης`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Επιλογή αντιγραφής`,
's624e31cd4f1b89d4': `Ομαλή κύλιση`,
's626daf42b1ab7df7': `Ευθυγράμμιση αριστερά`,
's6280bf993915c57a': `Περιθώριο κύλισης`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Περιγραφή`,
's63dfc5b1c1c27849': `Γίντις`,
's63e03c70f67ebf9c': `Πλαίσιο`,
's63e71d20d1eaca93': `Γερμανικά`,
's640bc7710d0143ce': `Επαναφορά της τελευταίας αλλαγής που ακυρώθηκε στο ενεργό έγγραφο`,
's64dc1fc7e3db45c9': `Δημιουργία νέου εγγράφου`,
's65ac276544ba33cd': `Αρχείο SVG`,
's66765c420ee578e4': `Χώρος ομοιόμορφα`,
's669b18c6d2d9c95b': `Κανένα`,
's6747dbf4ad6063ba': `Αυτο τέλος`,
's6787497df07fa97e': `Μπορεί να μετακινηθεί πάνω από στάσεις`,
's67c2b60a506a09e4': `Δευτεροβάθμια έκδοση.`,
's680bd4d926cd5a84': `Διατήρηση 3D`,
's6827930ef1aeaf99': `Βασική διεύθυνση URL`,
's684a16f3c711394d': `Over Right`,
's687e27f036a71b32': `Απομόνωση`,
's68b87d7b61052dc3': `Σειρά πίνακα`,
's68e0e3a2bab7ce3e': `Αποφύγετε το`,
's690da6b432987c6f': `Δημιουργία αντιγράφων ασφαλείας των αλλαγών στο τρέχον έγγραφο αυτόματα. Οι αλλαγές αποκαθίστανται κατά την επαναφόρτωση του WebWriter.`,
's69311c4e25074fb3': `Γυμνάσιο`,
's697400b541fbc3cd': `Κάτω από το`,
's6988ab5d47593a26': `Έχετε την τελευταία έκδοση του WebWriter.`,
's69a49786a8009f43': `Βρείτε πακέτα...`,
's69b12144dbb6544d': `Λαοθιανή`,
's69d88ef4b2618980': `Εξώφυλλο`,
's69fbbdb8ad2a084a': `Σκοτεινιάστε`,
's6a31eff1ec4f71ad': `Απόκρυψη πίσω όψης (3D)`,
's6ac62e1c8c66f3bb': `Compact superscr.`,
's6b585ba37cdb8260': `Κληρονόμος`,
's6b61f8abf89586be': `Εβραϊκά`,
's6bd7a02fdf93e653': `Ευθυγράμμιση περιεχομένου`,
's6cfc66b824ea05ba': `Τραγανές άκρες`,
's6d02dc19e21eb49c': `Κορυφή`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Βιετναμέζικα`,
's6d8b3b8047ed378d': `Λειτουργία ανάμειξης Mix`,
's6d8c02aee480af7a': `Μενού`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Εισαγωγή στυλ`,
's6e288a119281f4c2': `Απεικόνιση κειμένου`,
's6e4c20c6debcd5ca': `Προσαρμοσμένη δικαιολογήστε`,
's6f84199e62584905': `Προδιαμορφωμένο κείμενο`,
's6fb3053e7244d326': `Άλλα πεδία`,
's70178e04a3b691b6': `Άνοιγμα ρυθμίσεων`,
's7031ca562378bde6': `Γεωμετρική ακρίβεια`,
's7060970b5ed20a58': `Διαδραστικότητα`,
's7136449045eff28c': `Ταμίλ`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Εμφάνιση ασταθών πακέτων`,
's71dec51005acc1e4': `Σειρά πυκνή`,
's72f2a02e2a5a4ee3': `Μέσα ενημέρωσης`,
's730182ad28374cda': `Αντικείμενο`,
's731678e227a20559': `Αυτή η συσκευή`,
's736904f276fbd441': `Φυσικές επιστήμες`,
's739544d0c858c633': str`Ή ρίξτε 
          ${0} εδώ 
        `,
's73cb20c838e761e1': `Επιλογή κοπής`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pixelated`,
's743f778233e42a3f': `Εισάγετε μια παρένθεση`,
's744d993d03f29851': `Οθόνη`,
's748c0074eff45884': `Χειραγώγηση`,
's74aa0039a87141e2': `Ellipsis`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Πλαίσιο συμπλήρωσης`,
's75109f5307578a61': `Καλώς ήρθατε στο WebWriter`,
's75a27f43413e02c5': `Γαλλικά`,
's75d83fc3f0cfab40': `Κεφαλίδα`,
's762e5704cc84089d': `Ορισμός άλλων επιλογών στυλ των επιλεγμένων στοιχείων`,
's77318393dfdb0775': `Αφαίρεση γραμμής`,
's77e594ddcc10c774': `Να επιτρέπεται η εμπορική χρήση;`,
's782eac2b3e80323d': `Σημειώστε την επιλογή ως τονισμένη`,
's782f286a79cca35d': `Σχετικό`,
's78673a3539cb1915': `Επάνω αριστερά`,
's78789724e789221c': `Μέγεθος`,
's789ff24c8f03f1a4': `Απόσταση γραμμάτων`,
's7995733bf97c01cc': `Σερβοκροατικά`,
's7a99528e7b64635a': `Οξιτανικά`,
's7aaf0c06e69600f1': `Σφάλμα με `,
's7ae49e142487766c': `Κοινοτική πρόσβαση`,
's7af555180b30a947': `Ανοίξτε τα εργαλεία ανάπτυξης`,
's7b4ba250601b8667': `Εισαγωγή προτύπου`,
's7b560d8693ed8f42': `Όρθια`,
's7b9994904c4f5b54': `Τατζικιστάν`,
's7bdf0fd5b014d36c': `Ισχυρή σημασία`,
's7beb1e77e82363eb': `Αναίρεση της τελευταίας αλλαγής στο ενεργό έγγραφο`,
's7c61118554a0ec36': `Μέγιστο (x)`,
's7c95876637f6a9d7': `Φίλτρο`,
's7cb4e55c59663b1c': `Εταιρεία`,
's7cfe12cd14df9950': `Υπογράψτε έξω`,
's7d27db3c9639c6dd': `Εναλλακτική`,
's7d8103f6f06f83d6': `γεμίζω`,
's7d864465dddbb50d': `Επιτρέψτε την αλλαγή μεγέθους`,
's7de0e28d6c309a4e': `Επιτρέψτε ενέργειες αφής`,
's7dea785045c3cc74': `Πατήστε νέο συνδυασμό πλήκτρων...`,
's7e0b179d4d1414eb': `Εισάγετε σύνδεσμο`,
's7e6570f2f1ae320f': `Σύνθεση γραμματοσειρών`,
's7ecb1f29332293e5': `Βασική γραμμή ευθυγράμμισης`,
's7ed13ccddb1bf3c3': `Επικάλυψη`,
's7edbe0b213199995': `Πτυχίο`,
's7ede1c55e35ce9d6': `Προσομοίωση`,
's7f09197a4814079b': `Ορισμός επιλογών διαδραστικότητας για επιλεγμένα στοιχεία`,
's7f326a142e856656': `Στυλ`,
's7fcb35d23be1e643': `Σύνολο πεδίων`,
's80570196a9ce6d11': `Ενεργοποίηση τηλεμετρίας`,
's806f84eb0ace116e': `Δείτε τι έχετε επιλέξει και αλλάξτε το. Αντιγράψτε, κόψτε, επικολλήστε, καρφιτσώστε ή κάντε αλλαγές στη διάταξη. Προσφέρει διαφορετικές επιλογές ανάλογα με την επιλογή σας, π.χ. μορφοποίηση για το κείμενο.`,
's80a42b81c52d4d8f': `Χρώμα Caret`,
's80b71fc6f43c5ce1': `Χαλαρό`,
's812cbda653daaeba': `Αυτή η λειτουργία δεν έχει υλοποιηθεί ακόμη`,
's81c3d8809658b951': `Κασμίρι`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Συνεχίστε`,
's8247d32213e35f24': `Εισάγετε ένα κύριο`,
's82665b2ffabc9c0a': `Ιστοσελίδα`,
's828b1ecea8715884': `Pan (αριστερά)`,
's833bd0422a7ef95d': `Μέγεθος καρτέλας`,
's83420ad7b6a14db5': `Εναλλαγή Εργαλεία Dev`,
's83c15613b6f6f3c8': `Μόνο online`,
's83cd32b685ccc9b7': `Έλεγχοι`,
's83f26d02dd7aa681': `Ορατό`,
's840fa49e8989c028': `Θέση/Σχήμα`,
's844a76d1843ceb3c': `Επαναφορά στην προεπιλογή`,
's84e4e8ae645b82ac': `Επάνω δεξιά (y)`,
's84e9c7f8785ca60b': `Εισαγωγή φόρμας`,
's8517ae4da104b004': `Ομάδα στηλών πίνακα`,
's85186a61e0d55bac': `Βίντεο`,
's851a7deea5984646': `Άδεια χρήσης ως Creative Commons OER;`,
's85f9aa6d3ea0e421': `Ομάδα υποσέλιδων πίνακα`,
's864b0e6270e97246': `Σημειώστε την επιλογή ως δευτερεύον σχόλιο`,
's8670e5ad3bf0dcf8': `Αποθήκευση ως`,
's8688d74dd3716d6e': `Συντομεύσεις πληκτρολογίου για εντολές`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Περιθώριο σχήματος`,
's87cefc710b3567fb': `Περιέχει`,
's88676f992b2965db': `Τεντώστε το περιεχόμενο του κελιού`,
's886897f2fd4edb99': `Κρυφό`,
's886c5db2a5579873': `Έννοια`,
's888c71e8fcb916d3': `Αυτόματη αποθήκευση`,
's88a62d29529948fb': `Εισαγωγή πίνακα`,
's89950d86c8004d4b': `Παράλειψη χωρίς επικαλύψεις`,
's89bca7498f20e041': `Κλιπ φόντου`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Διάλειμμα πριν`,
's8a4ff2bd9c13498c': `Εγγραφή`,
's8a6585c48ea104e9': `Απόκρυψη κενών κελιών`,
's8a9eb438abac7c6a': `Ετικέτες`,
's8b0432eecbd8b034': `Ενημέρωση`,
's8b7580c35e2aef87': `Επάνω αριστερά (y)`,
's8bc4affa761aa8a2': `Εισαγωγή εικόνας`,
's8c7f51cb067644c7': `Κατάλογος δεδομένων`,
's8d342ecaa9e75b9b': `Σχέση`,
's8d797888455f4147': `Χώροι διαλείμματος`,
's8d83386457e91813': `Αναίρεση/επανάληψη των αλλαγών σας ή προεπισκόπηση από την οπτική γωνία του μαθητή.`,
's8d8643013a7754d1': `Ευθυγράμμιση κειμένου`,
's8df30fe2a50d3479': `Εισαγωγή ευκαιρίας αλλαγής γραμμής`,
's8e715248c3a78446': `Κόψτε την επιλογή`,
's8f29e48d6b9a1aa8': `Εισαγωγή γραμμής κεφαλίδας πίνακα`,
's8f4be9f086eb530f': `Αναίρεση`,
's8f533296a536965e': `Αποθήκευση ως...`,
's8fad58c831ecf017': `Δοχείο κειμένου Ruby`,
's8ffe7abcbed8eb43': `Κάθετα, από αριστερά προς τα δεξιά`,
's90105521fcc40453': `Οι λογαριασμοί WebWriter Cloud σας επιτρέπουν να αποθηκεύετε έγγραφα στο διαδίκτυο
          και να τα μοιράζεστε με τους μαθητές σας. Προσθέστε έναν λογαριασμό εδώ και θα είναι
          διαθέσιμος ως τοποθεσία για την αποθήκευση, τη φόρτωση, την κοινή χρήση και το άνοιγμα
          εγγράφων.`,
's9095f01a80a91594': `Σούπερ`,
's90f0fbc12e1e2b2f': `Παλέτα γραμματοσειρών`,
's90f7c1cf501ea0a7': `Χρώμα dodge`,
's91093e0b087911ba': `Θέση έμφασης`,
's919e1724f589c9b1': `Υποδοχή`,
's91c5ed7769d00b65': `Εισαγωγή ενσωμάτωσης`,
's9219acd5bef6269e': `Κάτω από αριστερά`,
's92548405912d46bf': `Ευθυγράμμιση κύλισης (y)`,
's9258280591309342': `Ευθυγράμμιση κύλισης (x)`,
's927d796559f49439': `Ιστορικό Προέλευση`,
's92b177e579ef7b97': `Έμφαση`,
's92f846b9be2e8e8d': `Χαρακτηρίστε την επιλογή ως πλάγια`,
's93566b84230af4f5': `Εισαγωγή εικόνας`,
's936aa0b239679585': `Εισάγετε ένα θεματικό διάλειμμα (συνήθως εμφανίζεται ως οριζόντια γραμμή)`,
's9370dc6afa716b57': `Σύνορα`,
's93f083e654a45715': `Μπρέτον`,
's94653c76b2d86a04': `Καθορισμένος όρος`,
's9485af2e7cd9418f': `Δημοτικό σχολείο`,
's94d2eee44b292567': `Εναλλαγή προηγμένων επιλογών`,
's94d61907ee22a8c1': `Κορεάτικα`,
's94eb1effbbb6498b': `Υπερχείλιση`,
's951aa3a6439f1271': `Δείκτης λίστας`,
's9565553d163fc92a': `Σενάριο`,
's957787fc6b7ea5c0': `Pan (επάνω)`,
's95d56e58f816d211': `Ολλανδικά`,
's95d8e41a64635c7c': `Λευκός χώρος`,
's95de7e1eff6c053e': `Οριζόντια, από πάνω προς τα κάτω`,
's960d3a90ac199368': `Ρετο-Ρουμανικά`,
's96532132a29dd542': `Εισαγωγή ήχου`,
's96a045dcade75ad0': `Στήλη πυκνή`,
's9781a5bb3fcb26a3': `Επιλέξτε πρώτα μια εταιρεία`,
's978522fbc9577a7e': `Σομαλοί`,
's97881699a2b21d5b': `Διάκενο γραμμής`,
's97aa76056a81bd36': `Μετρικές`,
's986facb3ecc9602c': `Πλάγια, από δεξιά προς τα αριστερά`,
's987abd19fac8cf55': `Υπο`,
's9896529e5cb20558': `Εξωτερικό αρχείο`,
's98977a87d1b93941': `Επαναφορά πληροφοριών, στυλ και σεναρίων`,
's990d0e0fa2ab00b5': `Γαλικία`,
's99229574e5692f19': `Γροιλανδική`,
's99a990f3841ad283': `Αρχεία της `,
's99b38e000175cc84': `Διαγραφή`,
's99f110d27e30b289': `Τίτλος`,
's9ab10fbf4c7a7322': `Θέση υπογράμμισης`,
's9abadcc828884d7b': `Περιοχή κειμένου`,
's9b7cd8860c8fc922': str`
          ${0}
          θα αντικατασταθεί. Είστε σίγουροι; 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Χρώμα φόντου`,
's9ca757effd747da9': `Ουρντού`,
's9caf10388ab3562f': `Στήλη πίνακα`,
's9cf68f87b8e6122f': `Αζερμπαϊτζάν`,
's9d167ef77aed79b6': `Στρώμα`,
's9d2d00982edafabb': `Τουρκικά`,
's9d430adc5be110e9': `Αντίστροφη σειρά`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Διαγραφή`,
's9df571714a1efb44': `Είναι διαθέσιμη μια αυτόματα αποθηκευμένη έκδοση αυτής της εξερεύνησης. Να την φορτώσετε;`,
's9e28faa598332e2b': `Εισαγωγή βίντεο`,
's9e3dbb678150edd4': `Ορισμός οικογένειας γραμματοσειράς`,
's9e40e59654c8ad67': `Στήλη`,
's9e85800d3700e31c': `Παρακολούθηση`,
's9e8d3665edde89a6': `Ναούρου`,
's9eefe6e57e4e1661': `Παραλλαγή γραμματοσειράς`,
's9f1ecdb3061d9cbc': `Διατήρηση χώρων`,
's9faf26107ed49fb9': `Εισαγωγή κελιού πίνακα`,
's9fbe26cfd7845469': `Χάουσα`,
's9fc686f7bbd941e2': `Μετάβαση`,
's9ff3121d30f88d52': `Κανονικό`,
's9ffe1bbe64712bf1': `Καμβάς`,
'sa00df4e39c72d3b4': str`
          ${0} δεν υποστηρίζεται 
        `,
'sa013e119fec906fb': `Σειρά`,
'sa01e7bf33563ef72': `Συνημμένο ιστορικό`,
'sa126cf8c627cec1e': `Απεικόνιση εικόνας`,
'sa13f72278add7513': `Κάτω από το δικαίωμα`,
'sa1647e3b36ec08d7': `Συνδυάστε όρθια`,
'sa172190ea21f9b1c': `Αποκτήστε πρόσβαση στις ρυθμίσεις, ανοίξτε μια εξερεύνηση ή δημιουργήστε μια νέα.`,
'sa1c6c459b9b5115c': `Απόλυτη`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Πρότυπο πλέγματος`,
'sa30c12014e955946': `Ρωσική`,
'sa30f1981fd1cd441': `Μέγεθος γραμματοσειράς`,
'sa311a24c1471a974': `Έγγραφο`,
'sa352d168b262aa06': `Εισαγωγή υποσέλιδου`,
'sa37fee6a52d18063': `Διαγραφή εγγράφου`,
'sa39c7ac1d37f3bce': `Χαρακτηρίστε την επιλογή ως "αμφίδρομη απομόνωση".`,
'sa3b4c01623211544': `Δύναμη`,
'sa40fd43756fa8913': `Περσικό`,
'sa417644bef21a9aa': `Ανώνυμο θέμα`,
'sa43800e28be1bdbc': `Χρώμα διακόσμησης`,
'sa477cb1825dceb3b': `Σουδανός`,
'sa492a51a707930fa': `Εισαγωγή ενός blockquote`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Λεζάντα στο κάτω μέρος`,
'sa50d3c35533f1d99': `Όλα τα πεδία`,
'sa53c5cb03a8fda50': `Καρφιτσώστε την επιλογή ως απόσπασμα στην παλέτα`,
'sa557ae6bee9148a6': `Πρόοδος`,
'sa589e1df65dde0ec': `Ορίστε το μέγεθος, το padding και τα περιθώρια των επιλεγμένων στοιχείων`,
'sa5c371b4bb75e590': `Αριστερά`,
'sa5c80e623459ffe4': `Εισαγωγή κεφαλίδας`,
'sa5df1bcdba46c3fb': `Εικόνα Λεζάντα`,
'sa602e3fd3f2d98fd': `Animation`,
'sa644d580d8a11e60': `Ευθυγράμμιση Ruby`,
'sa645d315510dc09e': `Επιλέξτε διαδρομή από το δίσκο`,
'sa65d4ad99f1d8c06': `Ορισμός φόντου κειμένου`,
'sa6607436f60ccc1a': `Εσθονικά`,
'sa6f8d27bca557059': `Μετακινήστε τα στοιχεία meta/link/style πάνω/κάτω σε αυτό το στοιχείο`,
'sa757645ad842da97': `Διατηρήστε τα διαλείμματα`,
'sa75b95980cd80e78': `Εκδότης`,
'sa7698b3d20a6d1ec': `Κύλιση`,
'sa778acc33947c7b8': `Ολοκλήρωση ξενάγησης`,
'sa78a67272a4a6f95': `Μαθηματική φόρμουλα`,
'sa79167651dce1e80': `Εναλλακτικό κείμενο`,
'sa7af797a46c7d09a': `Υποσέλιδο πίνακα`,
'sa7dbe35b758c138d': `Εισαγωγή καμβά`,
'sa7dc6b8ef3f595dc': `Εισαγωγή πηγής`,
'sa8279f8211b3950d': `Διατήρηση διαλειμμάτων και χώρων`,
'sa8b55cab62e439b5': `Αφαίρεση στήλης`,
'sa8bbe0197d31b423': `Σύντομη περιγραφή`,
'sa9ff3b762365abe6': `Προέλευση μετασχηματισμού (z)`,
'saa02e3762368ff35': `Προέλευση μετασχηματισμού (y)`,
'saa065776236bfa28': `Μετασχηματισμός προέλευσης (x)`,
'saa33768e03c45fc8': `Μέγεθος αρχείου`,
'saaad98061a20ac39': `Εισαγωγή μαθηματικού τύπου`,
'saab875d8cfcfe712': `Θέμα`,
'saad4380b9cc6cefd': `Εναλλαγή πάνω από`,
'saaec15c97a9e4245': `Αντίστροφη στήλη`,
'sab0c57df694a0a09': `Έναρξη trim`,
'sab4d9283896d9422': `Εικονοστοιχεία ανάλυσης Snap`,
'sab55faae8e165407': `Padding&lt;br&gt; όπως κενό`,
'sab5e7d2a069a2951': `Επαγγελματικό πιστοποιητικό.`,
'sab726d2db7e6b93d': `Κιρούντι`,
'sac687b8649989de8': `Ευθυγράμμιση δεξιά`,
'sac895c732f350ac5': `Σκούρο`,
'saced41ddda8b2354': `Βάση ευελιξίας`,
'sad190f86451081c0': `Νεπάλ`,
'sad6be321164d08c8': `Συμπαγή μαθηματικά`,
'sadd352cc7f6f2307': `Εκτός`,
'sae098810f946ca7c': `Ταγκαλόγκ`,
'sae185e6af80ec81e': `Σουηδικά`,
'sae1c7f13b7c0c47f': `Έναρξη`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Μαορί`,
'sae9d739068eee2c5': `Τατάρ`,
'saf312eaeec77a802': `Εισαγωγή καταλόγου περιγραφής (γλωσσάριο, κατάλογος όρων)`,
'saf3da7c95cb17260': `Σημειώστε την επιλογή ως υπερσέλιδο`,
'saf440a0a592f2835': `Ενημέρωση σε`,
'saf9e5134ba1a7d30': `Κλείσιμο κύλισης`,
'safc6f203342d09e2': `Ενεργοποιεί την προεπισκόπηση για το ενεργό έγγραφο`,
'sb0a7e3adf4a125ee': `Επάνω δεξιά`,
'sb0a974028c99ca6d': `Να επιτρέπονται προσαρμογές;`,
'sb0d4f0f7993cf085': `Ορισμός μεγέθους γραμματοσειράς`,
'sb0f3327210fe18fc': `Στήλες`,
'sb0f93c1c60c0249a': `Βάση Ruby`,
'sb1494c08c8c720d1': `Ορισμός χρώματος κειμένου`,
'sb19611adbc88f711': `Προχωρημένο: Εμφάνιση εντολών επεξεργασίας πηγής, π.χ. για να εμφανίσετε την HTML του εγγράφου ή να προσθέσετε προσαρμοσμένα στυλ και σενάρια.`,
'sb206d700d26b14ff': `Υπογράμμιση`,
'sb233557012dcb328': `Μετακινηθείτε προς τα κάτω`,
'sb26035b596566abf': `Ανώνυμο`,
'sb2cda80610c8d6ea': `Χώρος όλα`,
'sb2dc787b0983ebc6': `Λιθουανικά`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Κέντρο`,
'sb3ba3276ae93627c': `Εισαγωγή ενός προ-διαμορφωμένου μπλοκ κειμένου`,
'sb430f5b4824de0d3': `Επιλέξτε μια διάταξη`,
'sb43db07b24da018a': `Αμχαρικά`,
'sb45f9fb4dba6e71a': `Μη ρυθμισμένο`,
'sb4e003a459464d85': `Κούρδος`,
'sb4f0310e6787d098': `Ουζμπεκιστάν`,
'sb4f1dffbb6be6302': `Σαφής`,
'sb51270e19988f9bd': `Περιοχή`,
'sb59d621e3c93cc27': `Κοινά όρια κελιών`,
'sb5e9e1776242b028': `Αλληλεπιδράσεις`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Διδακτορικό`,
'sb6103872073d369e': `Εισάγετε λεπτομέρειες`,
'sb616811735bfbafd': `Κελί πίνακα`,
'sb628960829e223bb': `Παραλείψτε όλες τις επικαλύψεις`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Εφαρμογή και εισαγωγή`,
'sb66e2181a7b5738a': `Ενεργοποιώντας την τηλεμετρία, επιτρέπετε τη συλλογή και διατήρηση δεδομένων σύμφωνα με τις`,
'sb67e0e7c0869f982': `Διαφορά`,
'sb68e83cda6c85af8': `Κεφαλίδα πίνακα`,
'sb6b268120592dc53': `Χίντι`,
'sb6ca0a8bb3caae69': `Πάχος διακόσμησης`,
'sb70c17f7899f9b01': `Λατινικά`,
'sb71941f552f3504d': `Ορισμός ειδικής τιμής`,
'sb740eab4afd5a710': `Αυτόματη ροή πλέγματος`,
'sb741b6e0ca589122': `Στρώμα αναστροφής`,
'sb7c77d0415de05cf': `Εκτέλεση δοκιμών`,
'sb7fb7568f6883ab8': `Κοινή χρήση του ενεργού εγγράφου`,
'sb85774dc5d18ff0f': `Επιβεβαίωση`,
'sb85b1e36579852a6': `Μη έγκυρο email ή κωδικός πρόσβασης`,
'sb884fa76bfc55429': `Αραβικά`,
'sb8a3d4df7d1c5e6b': `Υπόλοιπο`,
'sb8f610a0e8df91fc': `Φωτεινότητα`,
'sb8f855b49234b81b': `Εφαρμογή`,
'sb905da066c10182c': `Πλέον πιο σκούρα`,
'sb940ade1bd81be7e': `Κάτω από Αριστερά`,
'sb9e9a7dd45966756': `Χαρακτηρίστε την επιλογή ως έντονη`,
'sba509fd8ed61d1d5': `Μη αποθηκευμένο αρχείο`,
'sba64d8954d027206': `Αδιαφάνεια`,
'sba88d90cd6c751b3': `Κανόνας στήλης`,
'sbaf0a7c417e388af': `Υγεία`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Τόνγκα`,
'sbb55f9f2d69fd327': `Φίλτρο φόντου`,
'sbb85a407d730e13d': `Εισαγωγή μιας αναζήτησης`,
'sbb86c6c96f598bb8': `Μικτή`,
'sbba0156f795d8c07': `Επεξεργασία επιλογής`,
'sbba865d4b437944f': `Χαρακτηριστικό`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Απεγκατάσταση του`,
'sbc5f2a81604baf9b': `Τίτλος 6`,
'sbc5f2b81604bb14e': `Τίτλος 5`,
'sbc5f2c81604bb301': `Τίτλος 4`,
'sbc5f2d81604bb4b4': `Επικεφαλίδα 3`,
'sbc5f2e81604bb667': `Επικεφαλίδα 2`,
'sbc6953a36ced943f': `πολιτική απορρήτου`,
'sbd181cd54b8402a4': `Επεξεργασία της επιλογής`,
'sbd35ee879d9cf770': `Κείμενο Ruby`,
'sbd40f40cbadd38d5': `Αφαιρέστε αυτό το πακέτο widget`,
'sbd72dc858de95ce8': `Βιρμανίας`,
'sbe3c60c65f129daa': `Ανθρωπιστικές επιστήμες`,
'sbe4a7c8f231739b3': `ή επικόλληση/απόθεση/επιλογή αρχείου`,
'sbe90de083557ef3e': `Σουαχίλι`,
'sbefb6064cba01844': `Εισάγετε ένα διάλειμμα γραμμής`,
'sbf00e1ee999ea94e': `Εισαγωγή σεναρίου`,
'sbf519920c2017d67': `Κρεμαστό`,
'sbfa01f189a68d3e9': `Flex grow`,
'sbff54e740c4086eb': `Εμφάνιση άγνωστων πακέτων`,
'sbfff51feacf30196': `Σανσκριτικά`,
'sc0ceaa9843510f67': `Τουρκμενιστάν`,
'sc1611c0558728a2a': `Θέση`,
'sc1a155cc25899250': `Ομάδα γραμμών πίνακα`,
'sc1aa1f6051b7102a': `Ρουμανικά`,
'sc1edebeaef92b7bd': `Σταθερή διάταξη πίνακα`,
'sc1fff4f356dfb2fb': `Μετασχηματισμός`,
'sc24bda3c061fddf8': `Περιοχή με δυνατότητα κλικ`,
'sc252a4e091763606': `Εισαγωγή υποσέλιδου πίνακα`,
'sc2536e077514accc': `Κύλιση`,
'sc275dd00036d16cb': `Αποσπάσματα χαρακτήρα`,
'sc28864200d2a3799': `Αντιγράψτε τον κωδικό QR ως εικόνα`,
'sc2a24a9dd41a9503': `Γραμμή διακόσμησης`,
'sc2b734cca2fa643b': `Pan (κάτω)`,
'sc2e2a0dbf03723b7': `Προχωρημένο: (Προειδοποίηση: Μπορεί να μην είναι ασφαλές)`,
'sc3998b77d72c2932': `Εισαγωγή ενός ιστότοπου (ως πλαίσιο γραμμής)`,
'sc3ac225273c8316b': `Γενικά`,
'sc3cfee84dbbf36ae': `Τοπικό αρχείο`,
'sc3f09a9b6fa4fbed': `Μέσα στο`,
'sc43767deea72e9f3': `Λίστα περιγραφής`,
'sc462bbdd36bcba6b': `Πλαίσιο αναφοράς`,
'sc4ee3e4ee994dafd': `Ουκρανικό`,
'sc50d09edf9325339': `Διάλογος`,
'sc52b67794c06a0d3': `Προοπτική προέλευσης (y)`,
'sc52e8b794c0913d6': `Προοπτική αρχή (x)`,
'sc53de149fcaad713': `Μεταξύ χαρακτήρων`,
'sc546f489f9c0cced': `Αλλάζει τη λειτουργία δοκιμής για το ενεργό έγγραφο.`,
'sc5bcf50d1b578d9f': `Ρυθμίσεις λειτουργίας γραμματοσειράς`,
'sc5cb39478b9b7625': `Σημειώστε την επιλογή ως δείκτη`,
'sc6415b50ff928294': `Στοιχείο λίστας`,
'sc650ff15b20fe9d3': `Περιστροφή (z)`,
'sc6578b15b2154365': `Περιστροφή (x)`,
'sc65aff15b2183e58': `Περιστροφή (y)`,
'sc6da0f4a7e4d710e': `Παράκαμψη γλώσσας γραμματοσειράς`,
'sc74e3567875ce255': `Τόσο η ετικέτα του widget σας όσο και το όνομα του πακέτου NPM σας`,
'sc7eb080b96e244df': `Μαλαισία`,
'sc8ac7ef92b95df3f': `Μετακίνηση (x)`,
'sc8af536e2084ade0': `Παλέτα`,
'sc8b022f92b992bc2': `Μετακίνηση (y)`,
'sc8b39af92b9c2d81': `Μετακίνηση (z)`,
'sc8d2c7f6c33a2b32': `Ορισμός στυλ κειμένου (στοίχιση, εσοχή, απόσταση κ.λπ.) των επιλεγμένων στοιχείων`,
'sc8fa0e3de389ef1c': `Προσαρμογή μεγέθους γραμματοσειράς`,
'sc9474bf7a0668d73': `Περίληψη`,
'sc94e314312a8900c': `Τσεχική`,
'sc980855a000b76ea': `Κάτω μέρος`,
'sc98b103772de63f4': `Φινλανδική`,
'sca7cfe2bef51b2a5': `Ρίζα`,
'sca7fed2bef53cb99': `Ρόλος`,
'scabe6ecee5e01fd2': `Μαλτέζικα`,
'scace301a88231cce': `Ενσωματώστε το`,
'scbc55f622ec078c1': `Προβολή κουτιού`,
'scbe537fc38ff4c13': `Αυτόματες στήλες πλέγματος`,
'scc1db59d292cbc4c': `Τμήμα`,
'scc56b218a2689c42': `Αρμένιοι`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Πλαίσιο Padding Box`,
'scd9cedeb5ece3adb': `Συνδυασμός`,
'scdf536b65be39ec5': ` Δημιουργία/εισαγωγή`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ιδεογραφικό`,
'sceecdd0bb404bc17': `Εισαγωγή ομάδας επιλογών`,
'scf00d48fd5953a03': `Ελληνική`,
'scf932840a69dbb7c': `Πορτογαλικά`,
'scf932a8577057752': `Υποσέλιδο`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Κάτω δεξιά`,
'sd01178c54f648118': `Στήλες ισορροπίας`,
'sd03bff50f87f82d4': `Χαρακτήρας με παύλα`,
'sd05a155fe09c2866': `Σε απευθείας σύνδεση όταν χρησιμοποιείτε`,
'sd0864ea6cb6ef22e': `Κοινότητα`,
'sd10fdbe6caf9a998': `Διάλειμμα γραμμής`,
'sd121d3b959b7888d': `Βελτιστοποίηση της ταχύτητας`,
'sd1a78e667a1a139f': `Σημειώστε την επιλογή ως εισαγωγή`,
'sd1cffad290ea5b3b': `Κρατήστε όλα τα`,
'sd1f10284eeb17b25': `Φίτζι`,
'sd1f44f1a8bc20e67': `Ηλεκτρονικό ταχυδρομείο`,
'sd1f81984eeb7c0e8': `Συμπλήρωση`,
'sd29dc07235eea0f5': `Προσφορά`,
'sd2addf69477cd4b4': `Πακέτο εισαγωγής`,
'sd2ed26defc646d47': `Φίλτρο φόντου`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Σταθερό`,
'sd3a288c1094b8a63': `Πλάτος κανόνα στήλης`,
'sd3c65ef5c380c046': `Ενσωματωμένο`,
'sd3dcb76f7b28adb8': `Λετονία`,
'sd3eca1e0f4209f6e': `Περικόψτε όλα`,
'sd3f402df8619ddcd': `Αυτές οι πληροφορίες για εσάς προστίθενται αυτόματα στα νέα έγγραφα. Μπορείτε να τις
          αλλάξετε για κάθε έγγραφο στον επεξεργαστή μεταδεδομένων.`,
'sd4368b12645d3c0f': `Εισαγωγή πύλης`,
'sd452cebf4a0313d1': `Εμφάνιση εντολών επεξεργασίας πηγής`,
'sd48cc52117f4d68b': `Ιταλικά`,
'sd52660ee947ca58b': `Εισαγωγή στήλης πίνακα`,
'sd588d17a1b25c220': `Υπερχείλιση κειμένου`,
'sd5be6f6d85fc0c9b': `Ζουλού`,
'sd5bf67958b08b4cf': `Τριτοβάθμια εκπαίδευση.`,
'sd5cf95145e4d89ca': `Ξεκαρφιτσώστε αυτό το απόσπασμα`,
'sd5fd9d11a92f5b1d': `Κάτω αριστερά (y)`,
'sd60c9bbc51375635': `Εισαγωγή ενός κουμπιού`,
'sd66c4767fa3dde28': `Χρώμα έμφασης`,
'sd679c8b1bf8cc8a5': `Μικρές κεφαλαιοποιήσεις`,
'sd7086c4425c53c80': `Οικογένεια γραμματοσειρών`,
'sd837f42ac7cbfb58': `Σχήμα (εξωτερικά)`,
'sd88076d2994ee0fb': `Αποκλεισμός`,
'sd89a2e529b31ef43': `Επιστροφή`,
'sd8a345e95668b73b': `Κάθετα, από δεξιά προς τα αριστερά`,
'sd8ce9e57270b030d': `Τέντωμα γραμματοσειράς`,
'sd8ecf227c7c49331': `Μαθηματικά`,
'sd8f923198e0c5c6a': `Τέλος`,
'sd9c21e5f60d6bdd8': `Δανικά`,
'sd9ff8e2612e63d50': `Διαστασιολόγηση πλαισίου συνόρων`,
'sda2d76b976502a8d': `Ανοίξτε...`,
'sda344aacb837387e': `Θέση στο δοχείο`,
'sda5b6fa8b771f996': `Πλεύση αριστερά`,
'sda9254d1f1228e1a': `Ουγγρικό`,
'sdb1595f5c742dfbb': `Είσοδος`,
'sdb711380a28fec75': `Εισαγωγή λίστας (διατεταγμένη)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Κάτω δεξιά (y)`,
'sdc48456f9a27ae02': `Γεννήτρια`,
'sdc70d81cf6c28533': `Γεωργιανή`,
'sdd1ff479d04ac140': `Δημόσιο`,
'sdd2fc8919a9c3111': `Λειτουργία ανάμειξης φόντου`,
'sdd35b688281b6dea': `Ιαπωνικά`,
'sddc49047f66a64ab': `Δεν παρέχεται περιγραφή`,
'sdef34fe08bb28b09': `Κινέζικα (απλοποιημένα)`,
'sdf62e305e1594805': `Σημειώστε την επιλογή με ένα σχόλιο ruby`,
'sdf946172dfa0328f': `Superscript`,
'sdf9bc5d9b7f3e3de': `Ευθυγράμμιση`,
'se036b53f145441cd': `Μικτό περιεχόμενο`,
'se06f459fccdc3ce9': `Ευθυγράμμιση της τελευταίας γραμμής κειμένου`,
'se0a782a8be8e018b': `Νορβηγικό`,
'se0cda6b80a1bb50f': `Σλοβακική`,
'se0f67eae944f8f94': `Σίγαση`,
'se1312d6528f9a259': `Γιορούμπα`,
'se16c5e66886fbc59': `Άρθρο`,
'se1f5bb0386c88f96': `Ορίζει το χρώμα του επιλεγμένου κειμένου`,
'se219da7b1e955c65': `Σαφής μορφοποίηση`,
'se25e4f2cb77b8be8': `Γλώσσα για τη διεπαφή WebWriter και νέα έγγραφα`,
'se2796c5824ec8916': `Ορατότητα περιεχομένου`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Οπουδήποτε`,
'se39c065efa467782': `Βάσκοι`,
'se3b4c857f91f80d7': `Συντομεύσεις πληκτρολογίου`,
'se47baf2fd16b9d2b': `Πρότυπο`,
'se48bd9e6c2a3109d': `Λογαριασμοί`,
'se58467472725ad0c': `Ανάλυση εικόνας`,
'se58f06c2b0583ff7': `Επιλέξτε συντεταγμένες`,
'se5dc1e97fb743ade': `Απόσταση`,
'se619a501d1bfe6a5': `Wrap`,
'se62385ac082368d2': `Σημειώστε την επιλογή ως πηγή αναφοράς`,
'se6297163cac9d276': `Επεξεργασία πηγής`,
'se633223a0b88625e': `Τοποθέτηση κυττάρων`,
'se638417c560cfe5c': `Διάλειμμα μέσα`,
'se64f418b4e733b6c': `Εισαγωγή εξόδου`,
'se79c0a3ac70d8fb3': `Αναλογία Asp. (x)`,
'se79fae3ac710dc36': `Αναλογία Asp. (y)`,
'se7fad370d8fb4cec': `Βελτιστοποίηση της αναγνωσιμότητας`,
'se8a94b4effa2033e': `Αλφαβητικό`,
'se95d4e55ea186d9a': `Χρώμα γραμμής κύλισης`,
'se96d43a515b8451c': `Σλοβενική`,
'se96fd76ba1b2975a': `Κεντρικό`,
'se9ac05f36b004eb0': `Κρύψτε την εισαγωγική ξενάγηση. Απενεργοποιήστε ώστε να εμφανιστεί ξανά η ξενάγηση.`,
'se9b1fec72ffd8f48': `Τοπικό`,
'sea24bdcaa2bd2dec': `Υποχρεωτικό snap`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Ενεργοποιεί τον επεξεργαστή μεταδεδομένων`,
'sea896ed51ad33287': `Δεν υπάρχουν διαθέσιμα συγκεκριμένα στυλ`,
'seaaaeb09e3b4e78b': `Εντολές επεξεργασίας`,
'seabae79729c4b2ad': `Εναλλαγή email`,
'seaecc8267bad6234': `Γυμνάσιο`,
'seaf97719986faf4f': `Χάσμα`,
'seb19675a580f0628': `Αποφύγετε τη στήλη`,
'seb4e52ef5ec7a7dc': `Χρώματα/Εφέ`,
'seb8982ae8c3cdcc5': `Ινδονησιακή`,
'sebbced89e0db2894': `Πρώτη γραμμή βάσης`,
'sec02109a0dd2a6c8': `Έμφαση χρώμα`,
'sec2557a35b702525': `Μεταβλητή`,
'sec2da4aa7a02b925': `Ισλανδική`,
'sec30fbb20f102670': `Εισαγωγή περίληψης`,
'sec8b0b6c729816b6': `Επικεφαλίδα Ομάδα`,
'seccd05955adb76bc': `Αφίσα`,
'sed17285cd25d6389': `Κατάλογος στον οποίο βρίσκεται το package.json`,
'sed318ec045c5144f': `Πάνω από`,
'sed713f1b916fb469': `Απόσταση συνόρων (x)`,
'sed74a31b9172942c': `Απόσταση συνόρων (y)`,
'sed86bd0deb2e5372': `Μετασχηματισμός κειμένου`,
'see2fcaedf9743ec6': `Τοποθεσία`,
'seec6798afe90ffc8': `Εκτύπωση`,
'sef00c258bc1ecf1e': `Αυτή η εξερεύνηση έχει μη αποθηκευμένες αλλαγές.`,
'sef23dd271edd4a8b': `Κάτω αριστερά`,
'sef24caccbd4645ef': `Συρρίκνωση Flex`,
'sef49aec68fd1dc66': `Όνομα`,
'sef73fe18e351eb35': `Λέξεις κλειδιά`,
'sef75f458d77491af': `Ομάδα επιλογών`,
'sefcf950b3cc4fc3b': `Γλώσσα`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Περιεχόμενα`,
'sf0cab2483f66aa2e': `Προσαρμοσμένο`,
'sf0e261e04eda82ff': `Εμφάνιση`,
'sf1045382c1fd9a85': `Ακριβή χρώματα εκτύπωσης`,
'sf14c35392ec7bf10': `Αυτή η λειτουργία δεν είναι διαθέσιμη στον Firefox. Είναι διαθέσιμη στο Chrome ή τον Edge.`,
'sf14f9d5f9f6ca342': `Συν αναπτήρα`,
'sf1868dc19e3917bb': `Ισπανικά`,
'sf190149f9d8bbb2a': `Λειτουργία εγγραφής`,
'sf1e79171c4856543': `Είσαι σίγουρος; Αυτή η ενέργεια δεν μπορεί να αντιστραφεί, όλες οι ρυθμίσεις σας θα
          διαγραφούν και θα μηδενιστούν.`,
'sf21c1f60c7515f44': `Σημειώστε την επιλογή ως δείγμα εξόδου`,
'sf21fb4f4b9e8911f': `Πλάτος`,
'sf22a3737146ec910': `Το WebWriter μπορεί να ενσωματώσει SVG απευθείας στο έγγραφο.`,
'sf2514d5dc78b1654': `Εισαγωγή widget`,
'sf28903d4ca0ddcfc': `Κατάργηση αυτού του λογαριασμού`,
'sf2ab37af0abc55ef': `Απόκρυψη εισαγωγικής ξενάγησης`,
'sf2bdb0b4d7b9c039': `Μπενγκάλι`,
'sf2cbb5e519264e67': `Αλλαγή μεγέθους τόσο οριζόντια όσο και κάθετα`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sf2d96d0eb32cb81f': `Σύνθεση animation`,
'sf2de3dbe2108637a': `Απεικόνιση σχήματος`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Εισαγωγή κομματιού`,
'sf3c4da68b08a2590': `Μαδαγασκάρη`,
'sf471ec2496f904cc': `Απορρίψτε τις αλλαγές`,
'sf4849bc200e279ed': `Λεζάντα πίνακα`,
'sf486ca1fdbe08645': `Εισαγωγή σχήματος`,
'sf4b537d4cbd8f5fd': `Κείμενο επάνω`,
'sf4e0e02a5277ef23': `Εισαγωγή μιας περιοχής κειμένου`,
'sf4f067d41efd4b83': `Κλίμακα (y)`,
'sf4f3cbd41f002b46': `Κλίμακα (x)`,
'sf4fa67d41f05a008': `Κλίμακα (z)`,
'sf5197db2d5f2926a': `Περιστροφή`,
'sf52d840949a980d1': str`
          ${0}
          θα διαγραφούν οριστικά. Είστε σίγουροι; 
        `,
'sf55d634dcc743595': `Υπηρεσίες`,
'sf59c9081d106dd9c': `Σημειώστε την επιλογή ως μεταβλητή`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Διαγραφή εγγράφου`,
'sf65df67a03bebe4b': `Απαιτείται για αυτό το widget`,
'sf6673729c03ae999': `Επαναφορά WebWriter`,
'sf67571992e7dc88e': `Πλήρης θητεία`,
'sf6b4934598f7ed10': `Επιτρέψτε την επιλογή`,
'sf6e1665c7022a1f8': `Κωδικός πρόσβασης`,
'sf79e0d78b56444f1': `Τέλος γραμμής`,
'sf7a5f7a7c80c3082': `Και οι δύο`,
'sf7c0eba7c822e3d6': `Τολμηρό`,
'sf86bd4d2982f3b74': `Σημειώστε την επιλογή ως κωδικό`,
'sf8e82313fa411494': `Χαρακτηρίστε την επιλογή ως σύνδεσμο`,
'sf955eff73fb6b573': `Σέρβικα`,
'sf9929e2d356260c5': `Πολλαπλασιάστε`,
'sf993bb199fefbe04': `Όλα`,
'sf9ecf969dd4b8164': `Και οι δύο άκρες`,
'sf9f2c719a04066ec': `Εφαρμογή`,
'sfa49a5bb1a5d353e': `Ιδιωτική πρόσβαση`,
'sfa59c7777e2a0eeb': `Εισαγωγή μιας λίστας δεδομένων`,
'sfaa0a67db5c11f72': `Εσοχή πρώτης γραμμής κειμένου`,
'sfb231a52211b133f': `Δεν υπάρχει αναδίπλωση κειμένου`,
'sfb68cae41d749423': `Αρχικό`,
'sfb9b6edb0ed378c9': `Πηγή αναφοράς`,
'sfbbab09dbe553571': `Εισαγωγή διανυσματικού σχεδίου (SVG)`,
'sfc00292e778b67e2': `Μετρητής`,
'sfc63e31ac7c956ed': `Επιλέξτε`,
'sfc815c9078bba30a': `Κατεβάστε τον κώδικα QR ως εικόνα`,
'sfcdd8e672c75b713': `Διεύθυνση`,
'sfcebd18506f1e535': `Ροή`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Έξοδος`,
'sfdb1e4d90981a535': `Μοιραστείτε αυτό το έγγραφο`,
'sfdeef3dccf409f81': `Αυτή η λέξη-κλειδί απαιτείται για τα widgets`,
'sfe6e758ad2603c1d': `Μάστερ`,
'sfee1c12daf838935': `Κάψιμο χρώματος`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Εισαγωγή διαλόγου`,
'sffa395f64ec6ac36': `Βουλγαρική`,
'sffdadf0a576fd802': `Ύψος`,
'spaceKey': `Διάστημα`,
'tabKey': `⭾ Καρτέλα`,
'upKey': `↑ Πάνω`,
's0dc07f97c821463c': `Comment selection`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
's2739460e44320108': `Chinese (Traditional)`,
'sdc12d4d35420eeb7': `Comments`,
's74540c1b595a229c': `TeX Formula`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'scbf29ce484222325': ``,
    };
  